export const FILE_FORMAT_ACEPT_REGEXP = /(.jpg|.jpeg|.png|.pdf)$/i;

export const FILE_FORMAT_ACEPT = [
  'image/png',
  'image/jpeg',
  'application/pdf',
];

export const IMAGE_FORMAT_ACEPT = [
  'image/png',
  'image/jpeg',
];